"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toyota = exports.Lexus = void 0;
var _styledComponents = require("styled-components");
var _index = _interopRequireDefault(require("../../LexusButton/index.styled"));
var _LexusTypography = require("../../LexusTypography");
var StyledLink = _interopRequireWildcard(require("../../Link/index.styled"));
var _index3 = _interopRequireDefault(require("../../MediaComponent/index.styled"));
var _index4 = _interopRequireDefault(require("../../PriceFormat/index.styled"));
var _ToyotaTypography = require("../../ToyotaTypography");
var _breakpoints = _interopRequireDefault(require("../../breakpoints"));
var Styled = _interopRequireWildcard(require("./index.styled"));
const Lexus = exports.Lexus = (0, _styledComponents.css)`
  ${Styled.Tile} {
    box-shadow: 0 0 6px 0 rgba(75, 75, 75, 0.5);
    padding: 20px;
    min-height: 523px;
    &:hover {
      box-shadow: 0 0 6px 0 rgba(75, 75, 75, 0.5);
    }
    &.isSimilarMatch {
      background: #EAEAEA;
    }
  }

  ${Styled.VehicleTile} {
    position: relative;
    .dg-heart-lexus {
      margin-top: 2px;
    }
    .tippy-popper{
      position: absolute!important;
      transform: none!important;
      width: calc(100% + 76px)!important;
      left: -38px!important;
      top: 14px!important;
      .tippy-tooltip{
        max-width: none!important;
        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.3);
      }
      button{
        background: rgba(56,56,56,.6);
      }
    }
    .react-tabs__tab-list{
      li {
        text-transform: uppercase;
        border-bottom: 2px solid transparent;
        ${(0, _LexusTypography.nobel)({
  weight: "bold",
  sizing: "link13",
  spacing: "0.52px"
})}
        &.react-tabs__tab--selected{
         border-bottom: 2px solid black;
        }
      }
    }
    .react-tabs__tab-panel {
      ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "link11",
  spacing: "0.44px"
})}
    }
    .react-tabs__tab-panel--selected {
     
    }
  }

  ${Styled.Name} {
    ${(0, _LexusTypography.nobel)({
  weight: "regular",
  sizing: "subheading16",
  spacing: "narrow"
})}
    letter-spacing: 0.64px;
  }

  ${Styled.IsPendingContainer} {
    margin: 0 0 5px;
    display:none!important;
  }
  
  ${Styled.IsPending} {
    font: inherit;
  }

  ${Styled.Jelly} {
    padding: 16px 0;
    margin: 0;
    aspect-ratio: 17/9;
    ${(0, _breakpoints.default)("tablet", "up")} {
      aspect-ratio: 13/9;
    }
    ${(0, _breakpoints.default)("tablet", "up")} {
      aspect-ratio: 17/9;
    }
  }

  ${Styled.Status} {
    color: #000;
    align-items: flex-start;
    margin: 0 0 15px;
    ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "body14",
  spacing: "narrow"
})}
    button {
      text-decoration-thickness: 0;
      text-underline-offset: 2px;
    }
  }

  ${Styled.StatusContainer} {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  ${Styled.StatusFilter} {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    height: 12px;
    gap: 10px;
    ${Styled.StatusLabel} {
      ${(0, _LexusTypography.nobel)({
  weight: "bold",
  sizing: "subheading16",
  spacing: "0.64px"
})}
      text-transform: uppercase;
      line-height: 11px;
    }
    ${Styled.StatusFilterLabel} {
      ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "subheading16",
  spacing: "0.64px"
})}
      line-height: 14px;
      button {
      text-transform: uppercase;
      }
    }
  }

  ${Styled.StatusMSRPText} {
    display: block;
  }

  ${Styled.PreviouslyViewed} {
    height: 22px;
    width: min-content;
    margin: 0 10px 0 auto;
    padding: 0 10px 0 0;
    border-right: 1px solid #999;
    text-align: right;
    color: #000;
    ${(0, _LexusTypography.nobel)({
  weight: "regular",
  sizing: "link10",
  spacing: "0.4px"
})}
    line-height: 12px;
  }

  ${Styled.StatusMSRP} {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;
    height: 7px;
    ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "legal10",
  spacing: "narrow"
})}
    letter-spacing: 0.2px;
    ${_index4.default.Symbol} {
    }
  }

  ${Styled.Swatch} {
    width: 25px;
    border: 1px solid #eaeaea;
    margin-right: 4px;
    ${_index3.default.ImgDom} {
      object-fit: cover;
    }
  }

  ${Styled.Description} {
    display: none;
    ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "link13",
  spacing: "narrow"
})}
  }

  ${Styled.FlexContainer} {
    justify-content: center;
    gap: 10px;
    margin: 0 0 35px;
  }

  ${Styled.Unit} {
    ${(0, _LexusTypography.pakt)("TileGrid-Unit", {
  weight: "normal",
  sizing: "subheading16",
  spacing: "narrow"
})}
  }

  ${Styled.MSRP} {
    display: flex;
    margin: 0 0 1px;
    ${(0, _LexusTypography.pakt)({
  weight: "normal",
  sizing: "display30",
  spacing: "narrow"
})}
    ${_index4.default.Price} {
      ${(0, _LexusTypography.pakt)({
  weight: "normal",
  sizing: "display30",
  spacing: "narrow"
})}
    }
    ${_index4.default.Symbol} {
      ${(0, _LexusTypography.pakt)({
  weight: "normal",
  sizing: "subheading16",
  spacing: "narrow"
})}
    }
  }

  ${Styled.MSRPContactCopy} {
    max-width: 150px;
    text-transform: uppercase;
    ${(0, _LexusTypography.pakt)({
  weight: "regular",
  sizing: "heading28",
  spacing: "narrow"
})}
    line-height: 27px;
  }

  ${Styled.MSRPCopy} {
    display: block;
    margin-right: 8px;
    ${(0, _LexusTypography.nobel)({
  weight: "regular",
  sizing: "legal10",
  spacing: "narrow"
})}
  }

  ${Styled.MSRPLinksContainer} {
    align-items: flex-start;
    ${(0, _LexusTypography.nobel)({
  weight: "bold",
  sizing: "link13",
  spacing: "narrow"
})}
  }

  ${Styled.DealerInfo} {
    margin-bottom: 22px;
  }

  ${Styled.DealerName} {
    justify-content: flex-start;
    ${(0, _LexusTypography.nobel)({
  weight: "regular",
  sizing: "link13",
  spacing: "wide"
})}
    text-transform: uppercase;
  }

  ${Styled.DealerDistance} {
    display: inline;
    ${(0, _LexusTypography.nobel)({
  weight: "regular",
  sizing: "link13",
  spacing: "wide"
})}
  }

  ${Styled.DealerIconContainer} {
    button {
      padding: 0;
    }
  }

  ${Styled.DealerIcon} {
    max-width: 82px;
    margin-right: 7.6px;
    height: 100%;
    &.hasBorder {
      padding-left: 10px;
      border-left: 1px solid #999;
    }
  }

  ${Styled.TileCTA} {
    margin-bottom: 0;
    width: 50%;
    max-width: 150px;
    min-width: fit-content;
    ${_index.default.A}, ${_index.default.Button} {
      min-width: fit-content;
      ${(0, _LexusTypography.nobel)({
  weight: "bold",
  sizing: "link11_14",
  spacing: "0.55px"
})}
    }
  }

  ${Styled.InventoryStatus} {
    margin-top: auto;
    ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "link11_14",
  spacing: "narrow"
})}
  }

  ${Styled.UnlockLink} {
    color: #a48b5b;
    text-decoration: none;
    ${(0, _LexusTypography.nobel)({
  weight: "bold",
  sizing: "link10",
  spacing: "narrow"
})}
  }

  ${Styled.StyledCompareVehicleToggle} {
    margin-top: unset;
  }
`;
const Toyota = exports.Toyota = (0, _styledComponents.css)`
  ${Styled.Tile} {
    border: 1px solid #EFEFEF;
    padding: 16px;
    min-height: 730px;
    &:hover {
      box-shadow: 0 4px 16px 0 rgb(0 0 0 / 8%);
    }
  }

  ${Styled.VehicleTile} {
    ${_index.default.A}, ${_index.default.Button} {
      width: 100%;
      padding: 6px 32px;
      height: initial;
      border-radius: 28px;
      ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "button01",
  spacing: "0.5px"
})}
    }
    .react-tabs__tab-list{
      li {
        padding: 13px 0 12px 0;
        ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "body02",
  spacing: "0"
})}
        &.react-tabs__tab--selected{
          ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "body02",
  spacing: "0"
})}
        }
      }
    }
    .react-tabs__tab-panel {
      ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "label10",
  spacing: "0"
})}
    }
    .react-tabs__tab-panel--selected {
    }
    ${Styled.TabContainer}{
      ${StyledLink.Anchor}, ${StyledLink.Button} {
        width: 100%;
      }
    }
  }

  ${Styled.NameWrapper} {
    margin: 4px 0;
  }

  ${Styled.Name} {
    margin: 0;
    min-height: 4.2em;
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "heading04",
  spacing: "0"
})}
  }

  ${Styled.VinStockWrapper} {
    margin-top: 4px;
  }

  ${Styled.Vin} {
    color: #58595B;
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "legal01"
})}
    line-height: 16px;
  }

  ${Styled.StockNum} {
    color: #58595B;
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "legal01"
})}
    line-height: 16px;
  }

  ${Styled.IsPendingContainer} {
    margin: 0 0 8px   ;
  }
  
  ${Styled.IsPending} {
    padding: 7px 8px;
    border-radius: 4px;
    background-color: #58595B;
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "label10",
  spacing: "0"
})}
  }

  ${Styled.Jelly} {
    padding: 0;
    aspect-ratio: 17/9;
    border-radius: 8px;
    overflow: hidden;
    margin: 16px 0 8px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      aspect-ratio: 21/9;
    }
    ${(0, _breakpoints.default)("tablet", "up")} {
      aspect-ratio: 17/9;
    }
  }
    
  ${Styled.JellyWrapper} {
    position: relative;
  }

  ${Styled.Status} {
    color: #767676;
    align-items: flex-start;
    margin: 0 0 4px 0;
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "label01",
  spacing: "0"
})}
    line-height: 20px;
    ${Styled.StatusMSRP} {
      display: block;
      padding: 0;
      border: none;
      margin: 0;
      font-size: 10px;
      line-height: 18px;
    }
  }

  ${Styled.StatusContainer} {
    display: block;
  }

  ${Styled.StatusFilter} {
    display: flex;
    flex-direction: row;
  }

  ${Styled.StatusMSRPText} {
    display: none;
  }

  ${Styled.PreviouslyViewed} {
    height: 100%;
    width: min-content;
    margin: 0 16px 0 auto;
    padding: 0 16px 0 0;
    border-right: 1px solid #D8D8D8;
    text-align: left;
    color: #767676;
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "overline01",
  spacing: "0"
})}
    line-height: 20.5px;
    @media only screen and (min-width: 1001px)  {
      margin: 0 8px 0 auto;
      padding: 0 8px 0 0;
    }
  
    @media only screen and (min-width: 1440px)  {
      margin: 0 16px 0 auto;
      padding: 0 16px 0 0;
    }
  }

  ${Styled.StatusMSRP} {
    ${_index4.default.Symbol} {
      vertical-align: initial;
      font-size: inherit;
    }
  }

  ${Styled.Swatch} {
    width: 22px;
    position: relative;
    border: 1px solid #D8D8D8;
    border-radius: 100px;
    margin-right: 4px;
    ${_index3.default.ImgDom} {
      border-radius: 100px;
      object-fit: fill;
    }
  }

  ${Styled.Description} {
    display: -webkit-box;
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "button01",
  spacing: "0"
})}
  }

  ${Styled.FlexContainer} {
    justify-content: space-between;
    gap: 0;
    margin: 0 0 16px;
  }

  ${Styled.FlexContainerColumn} {
    justify-content: space-between;
    gap: 9px;
    margin: 0 0 16px;
  }

  ${Styled.FlexText} {
    display: -webkit-box;
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "button01",
  spacing: "0"
})}
  }

  ${Styled.MSRP} {
    display: flex;
    margin: 0 0 8px;
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "heading04",
  spacing: "0"
})}
    ${_index4.default.Price} {
      ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "heading04",
  spacing: "0"
})}
    }
  }

  ${Styled.MSRPContactCopy} {
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "body02",
  spacing: "0"
})}
  }

  ${Styled.MSRPCopy} {
    color: #767676;
    display: inline-block;
    margin-right: 8px;
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "legal01",
  spacing: "0"
})}
  }

  ${Styled.MSRPContainer} {
    height: 52px;
  }

  ${Styled.DealerInfo} {
    height: 46px;
  }

  ${Styled.MSRPLinksContainer} {
    width: 28%;
    align-items: flex-end;
    gap: 12px;
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "label01",
  spacing: "0.25px"
})}
    ${StyledLink.Anchor}, ${StyledLink.Button} {
      color: #000000;
      text-decoration: underline;
      text-align: right;
      ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "label01",
  spacing: "0.25px"
})}
      &:hover{
        color: #000000;
      }
    }
      ${Styled.UnlockLink} {
       color: #E10A1D;
      }
  }

  ${Styled.DealerName} {
    justify-content: space-between;
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "regular",
  sizing: "label01",
  spacing: "0"
})}
    text-transform: initial;
  }

  ${Styled.DealerDistance} {
    color: #767676;
    display: inline-block;
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "legal01",
  spacing: "0"
})}
  }

  ${Styled.DealerIcon} {
    max-width: 74px;
  }

  ${Styled.TileCTA} {
    margin-bottom: 9px;
  }

  ${Styled.InventoryStatus} {
    color: #58595b;
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "legal01",
  spacing: "0"
})}
    font-size: 11px;
    line-height: 16px;
  }

  ${Styled.UnlockLink} {
    color: #e10a1d;
    text-decoration: underline;
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "label10",
  spacing: "0.21px"
})}
  }
`;